import { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Cookies = () => {
  const windowHeight = window.innerHeight;

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });
    };
  }, [windowHeight]);

  return (
    <>
      <Container fluid className="hero">
        <h1 className="reveal3 p-4">POLITYKA COOKIES</h1>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>INFORMACJE OGÓLNE:</h4>
          <p>
            Nasza strona internetowa korzysta z plików cookies, aby zapewnić Ci
            najlepsze możliwe doświadczenie podczas korzystania z serwisu.
            Poniżej znajdziesz szczegółowe informacje na temat rodzajów cookies,
            ich celów oraz sposobów zarządzania nimi.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>RODZAJE COOKIES:</h4>
          <p>
            Wyróżniamy następujące rodzaje plików cookies:
            <ul>
              <li>
                <strong>Niezbędne cookies</strong>: Są konieczne do działania
                strony, np. do zapamiętania Twojej zgody na korzystanie z
                cookies.
              </li>
              <li>
                <strong>Analityczne cookies</strong>: Służą do zbierania danych
                statystycznych o ruchu na stronie. Korzystamy z Google
                Analytics.
              </li>
              <li>
                <strong>Funkcjonalne cookies</strong>: Umożliwiają zapamiętanie
                Twoich preferencji, np. wybranego języka.
              </li>
              <li>
                <strong>Cookies stron trzecich</strong>: Są to pliki cookies
                dostarczane przez zewnętrzne serwisy, np. Google Maps, Google
                reCAPTCHA, Facebook i Messenger.
              </li>
            </ul>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>LISTA UŻYWANYCH COOKIES:</h4>
          <p>
            <table>
              <thead>
                <tr>
                  <th>Nazwa pliku cookie</th>
                  <th>Cel</th>
                  <th>Czas przechowywania</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <code>_ga</code>
                  </td>
                  <td>
                    Analityka (Google Analytics). Służy do rozróżniania
                    użytkowników. <br />
                    <br />
                  </td>
                  <td>2 lata</td>
                </tr>
                <tr>
                  <td>
                    <code>_ga_VW5WHW3VEY</code>
                  </td>
                  <td>
                    Analityka (Google Analytics). Używany do przechowywania
                    identyfikatora sesji. <br />
                    <br />
                  </td>
                  <td>2 lata</td>
                </tr>
                <tr>
                  <td>
                    <code>cookie_anten_sat</code>
                  </td>
                  <td>
                    Zapamiętanie Twojej zgody na korzystanie z cookies. <br />
                    <br />
                  </td>
                  <td>90 dni</td>
                </tr>
              </tbody>
            </table>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>JAK ZARZĄDZAĆ COOKIES:</h4>
          <p>
            Możesz zarządzać plikami cookies w ustawieniach swojej przeglądarki.
            Poniżej znajdziesz instrukcje dla najpopularniejszych przeglądarek:
            <ul>
              <li>
                <a
                  href="https://support.google.com/chrome/answer/95647"
                  target="_blank"
                >
                  Google Chrome
                </a>
              </li>
              <li>
                <a
                  href="https://support.mozilla.org/pl/kb/blokowanie-ciasteczek"
                  target="_blank"
                >
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a
                  href="https://support.microsoft.com/pl-pl/help/17442/windows-internet-explorer-delete-manage-cookies"
                  target="_blank"
                >
                  Internet Explorer
                </a>
              </li>
              <li>
                <a
                  href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac"
                  target="_blank"
                >
                  Safari
                </a>
              </li>
            </ul>
            Pamiętaj, że wyłączenie niektórych plików cookies może wpłynąć na
            funkcjonalność strony.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>PRAWA UŻYTKOWNIKA:</h4>
          <p>
            Zgodnie z RODO masz prawo do:
            <ul>
              <li>
                Wycofania zgody na wykorzystywanie cookies w dowolnym momencie.
              </li>
              <li>Dostępu do swoich danych osobowych.</li>
              <li>
                Usunięcia swoich danych (tzw. prawo do bycia zapomnianym).
              </li>
            </ul>
            Aby skorzystać z tych praw, skontaktuj się z nami poprzez{" "}
            <Link to="/contact">formularz kontaktowy</Link> lub napisz
            bezpośrednio na e-mail: <b>antensat.kontakt@gmail.com</b>.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>LINKI DO INNYCH DOKUMENTÓW:</h4>
          <p>
            Więcej informacji na temat przetwarzania danych osobowych znajdziesz
            w naszej <Link to="/policy">Polityce prywatności</Link>. Zasady
            korzystania ze strony opisane są w{" "}
            <Link to="/terms">Warunkach korzystania</Link>.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>FORMULARZ KONTAKTOWY</h4>
          <p>
            jeśli masz pytania dotyczące plików cookies lub chcesz skorzystać ze
            swoich praw, skontaktuj się z nami za pomocą{" "}
            <Link to="/contact">formularza kontaktowego.</Link>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>AKTUALIZACJA POLITYKI COOKIES</h4>
          <p>
            Niniejsza polityka cookies może być okresowo aktualizowana. W
            przypadku istotnych zmian poinformujemy Cię poprzez powiadomienie na
            stronie głównej.
          </p>
        </Row>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default Cookies;
